import '../styles/global.css'
import "../styles/instagram.css";
import { installLocalMocks } from "../lib/mockApi";

// Install the fetch patch at module-load time so it's active *before* any
// page component runs its `useEffect` and fires the first api.gisperg.wine
// request. A `useEffect(installLocalMocks)` fires too late — the page's
// data fetch has already resolved (with a CORS failure) by then.
// Guarded internally so it only kicks in on localhost.
installLocalMocks();

function App({ Component, pageProps }) {
    return <Component {...pageProps} />
}

export default App